<template>
    <AppHeader>
        <template v-slot:header-left>
            <h4 class="my-auto text-primary">Estadisticas</h4>
        </template>
    </AppHeader>
    <div class="container-fluid">
        <div class="col-12">
            <InputGroup class="mb-50" label="Filtros">
                <form v-on:submit.prevent="getData" class="container-fluid">
                    <div class="row">
                        <div class="col-5">
                            <label class="fs-7">Fecha inicio</label>
                            <AppInput type="date" v-model="startDate" />
                        </div>
                        <div class="col-5">
                            <label class="fs-7">Fecha término</label>
                            <AppInput type="date" v-model="endDate" />
                        </div>
                        <div class="col-2 d-flex flex-row">
                            <AppButton class="mt-auto mb-50 flex-grow-1" variation="primary" type="submit" style="height: 36px;"><i class="md-icon icon-search"></i></AppButton>
                            <AppButton @click="downloadCSV" class="d-none d-md-block mt-auto mb-50 ml-25"  style="height: 36px;">
                                <i class="md-icon icon-xls"></i>
                            </AppButton>
                        </div>
                    </div>
                </form>
            </InputGroup>
        </div>
        <div class="col-12">
            <PaymentTable v-if="payments.length !== 0" :payments="payments" />
        </div>
    </div>
</template>

<script>
import Payment from '@/models/Payment';
import PaymentTable from '@/components/PaymentTable.vue';
import AppHeader from '@/components/ui/AppHeader.vue';
import InputGroup from '@/components/ui/InputGroup.vue';
import AppInput from '@/components/ui/AppInput.vue';
import AppButton from '@/components/ui/AppButton.vue';
import { useMainStore } from '@/store';

export default {
    created(){
        this.getData()
    },
    components:{
        AppHeader,
        PaymentTable,
        InputGroup,
        AppInput,
        AppButton
    },
    data(){
        const today = (new Date()).toISOString()
        return {
            startDate: `${today.substring(0,8)}01`,
            endDate: today.substring(0,10) ,
            payments:[]
        }
    },
    methods:{
        async getData(){
            let query = Payment.include('store').where('is_paid', true)
            if(this.startDate !== null && this.endDate !== null){
               query = query.where('paid_between', `${this.startDate},${this.endDate}`) 
            }
            this.payments = await query.get()
        },
        downloadCSV(){
            const headers = ['ID Tienda', 'Tienda', 'ID Pago', 'Medio de pago', 'Plan', 'Fecha de pago', 'Monto']
            const data = this.payments.map((p)=>{
                return [p.store.id, p.store.name, p.id, p.payment_method, ( useMainStore().planById( p.store.plan_id ) ).name , p.payment_date, p.amount ]
            })
            const CSVData = [ headers , ...data  ]
            let csv = "data:text/csv;charset=utf-8,"
            CSVData.forEach( (rowArray)=>{
                let rowString = rowArray.join(',')
                csv += rowString + "\r\n" 
            } )
            window.open( encodeURI(csv) )
        }
    }
}
</script>